<div on:click class:hide={code.length === 0}>
    <slot />
</div>

<style>
div{
    font-size: 3em;
    padding: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    border-radius: 50%;
    color: #fff;
    background: linear-gradient(45deg, var(--peta), var(--exa));
    opacity: 1;
    transition: opacity 100ms ease-in-out;
}
div::before {
  content: "";
  padding-bottom: 100%;
  display: inline-block;
  vertical-align: top;
}
.hide {
    opacity: 0;
}
</style>

<script>
export let code = 'default'
</script>